import * as api from "../api";
import "regenerator-runtime/runtime";

export const signup = (formData, history) => async (dispatch) => {
  try {
    const { data } = await api.signup(formData);

    dispatch({ type: "SAVE_TOKEN", payload: data });

    history.push("/articles-list/articles");
  } catch (error) {
    return error.response.data;
  }
};
export const signin = (formData, history) => async (dispatch) => {
  try {
    const { data } = await api.signin(formData);
    dispatch({ type: "SAVE_TOKEN", payload: data });
    history.push("/articles-list/articles");
  } catch (error) {
    return error.response.data;
  }
};

export const getUser = async (id) => {
  try {
    const { data } = await api.getUser(id);
    return data;
  } catch (error) {
    return error.response.data;
  }
};
